import { Box, IconButton } from '@mui/material';
import { Switch } from 'types';

interface Props {
  switchItem: Switch;
  onClick: () => void;
  onDoubleClick: () => void;
  selected: boolean;
}

const SwitchItem = ({
  switchItem,
  onClick,
  onDoubleClick,
  selected,
}: Props) => {
  const getInstrumentImagePath = () => {
    let imageName = '';

    if (!switchItem.enabled) {
      imageName = `unit-disconnected.png`;
    } else {
      imageName = `unit-connected.png`;
    }

    return `analyzerImages/${imageName}`;
  };

  return (
    <Box component='div'>
      <IconButton
        onClick={onClick}
        onDoubleClick={onDoubleClick}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          fontSize: '1rem',
          ...(selected && {
            backgroundColor: (theme) => theme.palette.action.hover,
          }),
        }}
        size='large'
      >
        <img src={getInstrumentImagePath()} alt='' />
        {switchItem.name}
      </IconButton>
    </Box>
  );
};

export default SwitchItem;
